(function (angular) {
    'use strict';

    angular.module('ui.order.newOrder.progress', [])
        .directive('newOrderProgress', function () {
            return {
                restrict: "E",
                templateUrl: 'app/ui/order/newOrderView/newOrderProgress/newOrderProgress.html',
                scope: {
                    progressWnd: "=wnd",
                    progress: "=",
                    title: "@"
                },
                controller: 'NewOrderProgressController'
            };
        })

        .controller('NewOrderProgressController', function ($scope) {
            $scope.progressWndOptions = {
                title: $scope.title,
                modal: true,
                visible: false,
                width: "30%",
                animation: om.config.kendoWindowDefaultOptions.animation
            };

            $scope.progressBarOptions = {
                animation: false,
                max: 100,
                min: 0,
                type: "percent",
                width: "99%"
            }
        })
    ;
})(window.angular);
